import { Plugin, PluginKey } from "@tiptap/pm/state";
import { find } from "linkifyjs";


const isNullOrUndefined = (str) => {
    const isNull = str === null;
    const isUndefined = str === undefined;
    return isNull || isUndefined;
};

export const pasteHandler = (options) => {
    return new Plugin({
        key: new PluginKey("handlePasteLink"),
        props: {
            handlePaste: (view, event, slice) => {
                console.log("paste simplicity-link");
                const state = view?.state;
                const selection = state?.selection;
                const empty = selection?.empty;

                if (empty) {
                    return false;
                }

                let textContent = "";

                slice.content.forEach((node) => {
                    textContent += node.textContent;
                });

                // use Linkify find
                const link = find(textContent).find((item) => {
                    return item.isLink && item.value === textContent;
                });
                if (!textContent || !link) {
                    return false;
                }
                // TODO: determine if: is external
                // TODO: flag links as NOT SIMPLICITY LINKS
                // const html = (_a = event.clipboardData) === null || _a === undefined ? undefined : _a.getData("text/html");
                const clipboard = event.clipboardData;
                const html = isNullOrUndefined(clipboard) ? undefined : clipboard.getData("text/html");
                const hrefRegex = /href="([^"]*)"/;
                const existingLink = isNullOrUndefined(html) ? undefined : html.match(hrefRegex);
                const url = existingLink ? existingLink[1] : link.href;
                options.editor.commands.setMark(options.type, {
                    href: url,
                    url: url,
                    type: "undetermined",
                });
                return true;
            },
        },
    });
};
